export enum Conditions {
  BU = 'БУ',
  NEW = 'Новый',
}